import { render, staticRenderFns } from "./localData.vue?vue&type=template&id=232e37d1&scoped=true"
import script from "./localData.vue?vue&type=script&lang=js"
export * from "./localData.vue?vue&type=script&lang=js"
import style0 from "./localData.vue?vue&type=style&index=0&id=232e37d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e37d1",
  null
  
)

export default component.exports